import { executeRequest, Request } from '@jfs/network'
import { APIEndPoints } from './APIEndpoints'
import { sitConfig } from './config'

const responseParser = (data: any) => {
  return data?.data?.content
}

const getSubsTxnDetailsV3 = (req: any, tokens: any, userAccessToken: string) => {
  const request: Request<{}> = {
    config: sitConfig(tokens),
    apiPath: APIEndPoints.getSubsTxnDetailsV3,
    method: 'POST',
    cache: false,
    body: req,
    headers: {
      Authorization: userAccessToken,
    },
  }
  return executeRequest(request).then((data) => {
    return responseParser(data.data)
  })
}

export { getSubsTxnDetailsV3 }
